import React, {Component} from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import { encrypt , decrypt , getParams } from "../../helpers/CryptoJs";
import AlbumContainer from "../../components/AlbumContainer";
import Chatbar from "../../components/Chatbar";


class Album extends Component {
  constructor(props){
    super(props);
    const search = this.props.location.search;
    const params = new URLSearchParams(search);
    
    this.state = {
        albumId  : decrypt(this.props.match.params.id),
    };
  }
  shouldComponentUpdate(nextProps, prevProps, prevState) {
    return true;
  }
  componentDidUpdate(prevProps, prevState) {
    
    const { pathname } = this.props.location;
    const { pathname: prevPathname } = prevProps.location;
    const type = `/album/:id`;
    const currentParams = getParams(pathname , type);
    const prevParams = getParams(prevPathname , type);
    if (currentParams.id && currentParams.id !== prevParams.id) {
      this.setState({
        userId: decrypt(currentParams.id),
      });
    }
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    document.querySelector('body').classList.remove('login_page');
  }
  render() {
    return (
      <div className="wrapper">
        <Header/>
        <Sidebar/>
        <AlbumContainer urlId={this.state.albumId} />
        <Chatbar />
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
  
  }
}
const mapDispatchToProps = dispatch => {
  return {
    
  }
}
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Album));